module.exports = __webpack_public_path__ + "img/cliente.32d53aa2.png";